// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { BuildAssembly } from './build-assembly';
import { BuildAssemblyDetailPart } from './build-assembly-detail-part';
import { Part } from './part';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class BuildAssemblyDetail extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  buildAssemblyId!: number;
  builtBy?: string;
  created?: Date;
  deleted?: Date;
  description?: string;
  lineNumber!: number;
  notes?: string;
  partCount?: number;
  partId?: number;
  partNumber?: string;
  quantity!: number;
  status!: number;
  buildAssembly!: BuildAssembly;
  part!: Part;
  parts!: BuildAssemblyDetailPart[];
}

